import {
    ArchiveTrackedEventTypeCommand,
    CanDeletePhysicalTargetTypeResponse,
    CanDeleteTaskTypeResponse, CreateOrdoConnectDeviceRegistrationCommand,
    CreatePhysicalTargetTypeCommand,
    CreateTaskTypeCommand,
    CreateTrackedCountTypeCommand, CreateTrackedDaysSinceLastIncidentTypeCommand,
    CreateTrackedEventTypeCommand, DepartmentDailyReportConfiguration, DepartmentDailyReportConfigurationViewModel,
    ExportResponse,
    GetKeyPhysicalTargetsForDepartmentWeekQueryResult,
    GetWeekHasExistingKeyPhysicalTargetsQueryResponse,
    KeyPhysicalTargetsImportViewModel,
    KeyPhysicalType, OrdoConnectDeviceRegistrationViewModel,
    PhysicalTargetTypeViewModel,
    ReportingMonthsImportViewModel,
    ReportingMonthYearViewModel,
    RestoreTrackedEventTypeFromArchiveCommand,
    TaskType, TrackedCountTypeViewModel, TrackedDaysSinceLastIncidentTypeViewModel,
    TrackedEventTypeViewModel, UpdateDepartmentDailyReportConfigurationCommand,
    UpdateOrdoConnectDeviceRegistrationCommand,
    UpdatePhysicalTargetTypeCommand,
    UpdateTaskTypeCommand, UpdateTrackedCountTypeCommand, UpdateTrackedDaysSinceLastIncidentTypeCommand,
    UpdateTrackedEventTypeCommand,
    UploadResponseViewModel,
    WeekViewModel
} from '@/models/api';
import AppHttp from '@/lib/AppHttp';

export class ConnectDevices {
    private resource: string = 'Connect/Devices';

    public async getDevicesByDepartment(departmentId: string): Promise<OrdoConnectDeviceRegistrationViewModel[]> {
        const response = await AppHttp.get(`${this.resource}/${departmentId}`);
        const data = response ? response.data : [];
        return data;
    }

    public async createDeviceRegistration(mineAreaId: string, command: CreateOrdoConnectDeviceRegistrationCommand): Promise<any> {
        const response = await AppHttp.post(`${this.resource}/${mineAreaId}/Create`, command);
        const data = response ? response.data : [];
        return data;
    }

    public async updateDeviceRegistration(mineAreaId: string, command: UpdateOrdoConnectDeviceRegistrationCommand): Promise<any> {
        const response = await AppHttp.post(`${this.resource}/${mineAreaId}/Update`, command);
        const data = response ? response.data : [];
        return data;
    }

    public async deleteDeviceRegistration(mineAreaId: string, deviceId: string): Promise<any> {
        const response = await AppHttp.delete(`${this.resource}/${mineAreaId}/${deviceId}`);
        const data = response ? response.data : [];
        return data;
    }

    public async refreshDeviceRegistrationCode(mineAreaId: string, deviceId: string): Promise<any> {
        const response = await AppHttp.post(`${this.resource}/${mineAreaId}/${deviceId}/Code/Refresh`, null);
        const data = response ? response.data : [];
        return data;
    }
}

export default new ConnectDevices();
